var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 2.33337C7.55992 2.33337 2.33325 7.56004 2.33325 14C2.33325 20.44 7.55992 25.6667 13.9999 25.6667C20.4399 25.6667 25.6666 20.44 25.6666 14C25.6666 7.56004 20.4399 2.33337 13.9999 2.33337ZM15.1666 22.1667H12.8333V19.8334H15.1666V22.1667ZM17.5816 13.125L16.5316 14.1984C15.9483 14.7934 15.5283 15.33 15.3183 16.17C15.2249 16.5434 15.1666 16.9634 15.1666 17.5H12.8333V16.9167C12.8333 16.38 12.9266 15.8667 13.0899 15.3884C13.3233 14.7117 13.7083 14.105 14.1983 13.615L15.6449 12.145C16.1816 11.6317 16.4383 10.8617 16.2866 10.045C16.1349 9.20504 15.4816 8.49337 14.6649 8.26004C13.3699 7.89837 12.1683 8.63337 11.7833 9.74171C11.6433 10.1734 11.2816 10.5 10.8266 10.5H10.4766C9.79992 10.5 9.33325 9.84671 9.51992 9.19337C10.0216 7.47837 11.4799 6.17171 13.2883 5.89171C15.0616 5.61171 16.7533 6.53337 17.8033 7.99171C19.1799 9.89337 18.7716 11.935 17.5816 13.125V13.125Z",
    fill: "#2BACE2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionHelp);
export default __webpack_public_path__ + "static/media/action-help.1449f7505aa00242a225584fda3e23c9.svg";
export { ForwardRef as ReactComponent };